(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gilas-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gilas-community-autoplay')) {
    customElements.define('gilas-community-autoplay', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(async () => {
          await customElements.whenDefined('slideshow-component');
          if (!this.isConnected) return;
          const slideshow = this.querySelector('.gilas-community__gallery');
          if (!slideshow) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          const mobile = matchMedia('(max-width: 749px)');
          const motion = matchMedia('(prefers-reduced-motion: reduce)');
          let visible = false;
          const sync = () => {
            const playing = mobile.matches && visible && !document.hidden && !motion.matches;
            if (playing) slideshow.play();
            else slideshow.pause();
          };
          mobile.addEventListener('change', sync, { signal });
          motion.addEventListener('change', sync, { signal });
          document.addEventListener('visibilitychange', sync, { signal });
          this.observer = new IntersectionObserver(([entry]) => {
            visible = entry.isIntersecting;
            sync();
          }, { threshold: 0 });
          this.observer.observe(slideshow);
          this.slideshow = slideshow;
          sync();
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.slideshow?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  class GilasCarouselProgress extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.querySelector('slideshow-component');
      this.slideshow?.setAttribute('data-scroll-step', 'single');
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this.handleKeydown);
      this.slideshow?.removeAttribute('data-scroll-step');
    }

    handleKeydown = (event) => {
      if (event.target !== this) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.slideshow?.previous(event);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.slideshow?.next(event);
      }
    };

  }

  if (!customElements.get('gilas-carousel-progress')) {
    customElements.define('gilas-carousel-progress', GilasCarouselProgress);
  }

  } catch(e) { console.error(e); }
})();
})();
